import React from 'react';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.2876 1.29352L5.63756 6.95352C3.06321 9.52618 2.29213 13.3977 3.68481 16.7615C5.0775 20.1253 8.3596 22.3187 12.0003 22.3187C15.641 22.3187 18.9231 20.1253 20.3158 16.7615C21.7085 13.3977 20.9374 9.52618 18.3622 6.95266L12.7024 1.29289C12.3116 0.902125 11.678 0.902405 11.2876 1.29352ZM7.05217 8.36734L11.9953 3.415L16.9482 8.36711C18.9514 10.369 19.5511 13.3801 18.4679 15.9964C17.3847 18.6127 14.8319 20.3187 12.0003 20.3187C9.16864 20.3187 6.6159 18.6127 5.5327 15.9964C4.4495 13.3801 5.04923 10.369 7.05217 8.36734Z"
        fill="#191919"
      />
    </Svg>
  );
};

export default Icon;
